import { computed, defineComponent, onMounted, ref } from 'vue';
import { Popover } from 'bootstrap';
import { useSweetAlert } from '@/composables/sweetalert';
import { useStore } from 'vuex';
import { CompleteAction, CompleteGetter } from '@/store/complete/complete.module';
import { Project } from '@/store/project/project.model';

export default defineComponent({
  name: 'DoneTableComponent',
  setup: () => {
    const swal = useSweetAlert();
    const store = useStore();
    const projects = computed<Project[]>(() => store.getters[CompleteGetter.DONE]);
    const popoverList = ref<Popover[]>([]);

    onMounted(() => {
      store.dispatch(CompleteAction.FETCH_DONE)
        .then(() => initialPopover());
    });


    const selectedClick = (id: number) => {
      swal.confirm('จบโครงการ!', 'คุณต้องการจบโครงการใช่หรือไม่?', 'ใช่ ดำเนินการเดี๋ยวนี้!', '#3b7ddd')
        .then((result) => {
          if (result.isConfirmed) {
            store.dispatch(CompleteAction.FINISHED, { projectId: id });
          }
        });
    };

    const initialPopover = () => {
      const popoverTriggerList = computed<HTMLElement[]>(() => [].slice.call(document.querySelectorAll('[data-bs-toggle="popover-done"]')) as HTMLElement[]);
      popoverList.value.map(element => element.hide());
      popoverList.value = popoverTriggerList.value?.map(element => new Popover(element, { trigger: 'hover', placement: 'right' }));
    };

    return {
      projects,
      selectedClick,
    };
  },
});
